import { render, staticRenderFns } from "./ContentFeedItem.vue?vue&type=template&id=4998c41b&"
import script from "./ContentFeedItem.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports